import { z } from 'zod';
import { TASK_REPEATS, WIDGET_TYPES } from '../enums';
import { zDateOnly, zIdList, zOptId, zOptText, zText } from './common';

export const dashboardSchema = z.object({ name: zText(80) });

export const widgetSchema = z.object({
  widgetType: z.enum(WIDGET_TYPES),
  title: zOptText(80),
  settings: z.record(z.string(), z.unknown()).default({}),
});
export const widgetUpdateSchema = z.object({
  title: zOptText(80),
  settings: z.record(z.string(), z.unknown()).optional(),
});
export const widgetReorderSchema = z.object({ sequence: zIdList.min(1) });

export const taskListSchema = z.object({
  name: zText(80),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Color inválido').default('#3b6e8f'),
  campusId: zOptId,
});

export const taskSchema = z.object({
  title: zText(200),
  description: zOptText(5000),
  assigneePersonId: zOptId,
  dueOn: zDateOnly.nullable().optional(),
  repeat: z.enum(TASK_REPEATS).default('none'),
});
export const taskUpdateSchema = taskSchema.partial().extend({ status: z.enum(['open', 'done']).optional() });
